import _defineProperty from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty";

var _types$FETCH_PALM_PRI;

import * as types from "@/store/constants/types";
export default (_types$FETCH_PALM_PRI = {}, _defineProperty(_types$FETCH_PALM_PRI, types.FETCH_PALM_PRINT_DATA, function (state, payload) {
  state.palm_print_data = payload;
}), _defineProperty(_types$FETCH_PALM_PRI, types.FETCH_FACE_READING_DATA, function (state, payload) {
  state.face_reading_data = payload;
}), _defineProperty(_types$FETCH_PALM_PRI, types.UPDATE_READING_LIST, function (state, payload) {
  state.reading_data_list = payload;
}), _types$FETCH_PALM_PRI);